import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useProjectListHook } from '@/hooks/projectHook';
import styles from '@layout/layout.module.css';

const StyledArticle = styled.dl`
  height: 11rem;
  width: calc(33.33% - 6.66px);
  padding: 1rem 1.5rem;
  cursor: pointer;
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
  }

  &:hover {
    background-color: var(--main2-bg-color);
  }

  ${(props) =>
    props.onClick &&
    `
  &::after {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    content: '${props.content}';
    color: gray;
    font-size: 0.8rem;
  }
  `}

  & dt {
    margin-bottom: 1rem;
  }

  & dd,
  & dt {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & dd:nth-child(2) {
    margin: 0.5rem 0;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  && dd:last-child {
    display: flex;
    font-size: 0.8rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    gap: 10px;
  }
`;

const SkeletonArticle = () => {
  return (
    <StyledArticle className={styles.shadow}>
      <div className={styles.skeleton}>
        <dt>title</dt>
        <dd>detail</dd>
        <dd>skills</dd>
      </div>
    </StyledArticle>
  );
};

const RealArticle = ({ item, onClick }) => {
  return (
    <StyledArticle
      className={styles.shadow}
      onClick={onClick}
      content={useTranslation().t('learn_more').toString()}
    >
      <dt>{item.title}</dt>
      <dd>{item.detail}</dd>
      <dd>
        {item.skills?.map((skill, j) => (
          <span key={`${item.title}_skill${j}`}>#{skill}</span>
        ))}
      </dd>
    </StyledArticle>
  );
};

const SectionWork = () => {
  const navigate = useNavigate();
  const { loadDone, data } = useProjectListHook();

  const handleClick = (item) => () => {
    navigate(`project/${item.title}`, {
      state: item,
    });
  };

  return loadDone ? (
    <div>
      {data.map((item, i) => (
        <RealArticle
          key={`project${i}`}
          item={item}
          onClick={handleClick(item)}
        />
      ))}
    </div>
  ) : (
    <div>
      {Array.from(Array(3), (_, i) => (
        <SkeletonArticle key={`project${i}`} />
      ))}
    </div>
  );
};

export default SectionWork;
